import classNames from 'classnames'
import React from 'react'

import Image from '@/components/Image'
import Link from '@/components/Link'

const RessourceCardLink = (link) => {
  return (
    <Link link={link.link} className='lg:flex-1'>
      <div className='flex flex-col gap-4 py-3'>
        <div
          className={classNames('misc-button-s fit-content flex rounded-lg px-2 py-1 uppercase ', {
            'bg-purple-400 text-white': link.badgeColor === 'purple',
            'text-purple-700 bg-turquoise-400': link.badgeColor === 'turquoise',
            'bg-violet-400': link.badgeColor === 'violet',
            'bg-yellow-400 text-purple-900': link.badgeColor === 'yellow',
          })}
        >
          {link.badge}
        </div>
        <div className='aspect-h-4 aspect-w-9 overflow-hidden rounded-lg'>
          <Image {...link.icon} className='w-full object-cover' />
        </div>
        <div className='flex flex-col gap-1'>
          <div className='body-s-medium'>{link.Label}</div>
          <div className='body-xs-regular text-purple-400'>{link.description}</div>
        </div>
      </div>
    </Link>
  )
}

export default RessourceCardLink
